import { useTranslation } from "react-i18next";
import { User, Bot, Wrench } from "lucide-react";

const RoleBadge = ({ role }) => {
    const config = {
        human: { icon: User, label: "User", bg: "bg-blue-100 text-blue-800" },
        assistant: { icon: Bot, label: "Assistant", bg: "bg-green-100 text-green-800" },
        tool: { icon: Wrench, label: "Tool Result", bg: "bg-amber-100 text-amber-800" },
    };
    const c = config[role] || config.human;
    const Icon = c.icon;
    return (
        <span className={`inline-flex items-center gap-1 px-2 py-0.5 rounded text-xs font-medium ${c.bg}`}>
            <Icon className="h-3 w-3" /> {c.label}
        </span>
    );
};

export default function ConversationTab({ data }) {
    const { t } = useTranslation();
    const history = data?.debug?.conversationHistory || [];

    if (history.length === 0) {
        return <p className="text-muted-foreground text-sm p-4">{t("admin.automationPlayground.noHistory")}</p>;
    }

    return (
        <div className="space-y-3 mt-3">
            {history.map((msg, i) => (
                <div key={i} className="border rounded-lg p-3 bg-white">
                    <div className="flex items-center gap-2 mb-2">
                        <RoleBadge role={msg.role} />
                        {msg.name && (
                            <span className="text-xs text-slate-500 font-mono">{msg.name}</span>
                        )}
                        {msg.tool_call_id && (
                            <span className="text-xs text-slate-400 font-mono">id: {msg.tool_call_id}</span>
                        )}
                    </div>
                    <pre className="text-sm whitespace-pre-wrap break-words font-mono bg-slate-50 p-2 rounded max-h-96 overflow-auto">
                        {msg.content}
                    </pre>
                    {msg.tool_calls && msg.tool_calls.length > 0 && (
                        <div className="mt-2 space-y-1">
                            <p className="text-xs font-medium text-slate-500">
                                {t("admin.automationPlayground.toolCalls")}:
                            </p>
                            {msg.tool_calls.map((tc, j) => (
                                <div key={j} className="bg-amber-50 border border-amber-200 rounded p-2">
                                    <span className="text-xs font-mono font-bold text-amber-700">{tc.name}</span>
                                    <pre className="text-xs font-mono mt-1 whitespace-pre-wrap max-h-48 overflow-auto">
                                        {JSON.stringify(tc.args, null, 2)}
                                    </pre>
                                </div>
                            ))}
                        </div>
                    )}
                </div>
            ))}
        </div>
    );
}
